import { List, Typography, Checkbox } from 'antd';
import { useTranslation } from 'react-i18next';
import { ContentContainer, ScrollableList } from './ui';

type DuplicateIds = {
    label: string;
    key: string;
    value: boolean;
};

export type UpdateDuplicateContentProps = {
    duplicates: DuplicateIds[];
    onDuplicateClick: (item: DuplicateIds) => void;
};

const UpdateDuplicateContent = ({ duplicates, onDuplicateClick }: UpdateDuplicateContentProps) => {
    const { t } = useTranslation('importExportExcel');

    return (
        <ContentContainer direction="vertical">
            <Typography.Text>{t('importExportExcel:description.duplicateTitle')}</Typography.Text>
            <ScrollableList
                dataSource={duplicates}
                renderItem={(item: DuplicateIds) => (
                    <List.Item>
                        <Checkbox checked={item.value} onChange={e => onDuplicateClick(item)}>
                            {item.label}
                        </Checkbox>
                    </List.Item>
                )}
            />
        </ContentContainer>
    );
};

export default UpdateDuplicateContent;
